<script lang="ts" setup>
import { computed } from 'vue';
import { useTransition } from '../shared/composables/transition';
import type { TransitionProps } from '../types';

export type ExpandTransitionProps = TransitionProps & {
  direction?: keyof typeof directionClasses;
};

const props = withDefaults(defineProps<ExpandTransitionProps>(), {
  direction: 'vertical',
});

const directionClasses = {
  horizontal: {
    active: 'motion-safe:transition-[opacity,padding,width]',
    hidden: 'w-0! px-0!',
    visible: 'w-auto',
  },
  vertical: {
    active: 'motion-safe:transition-[height,opacity,padding]',
    hidden: 'h-0! py-0!',
    visible: 'h-auto',
  },
} as const satisfies Record<string, Record<string, string>>;

const { classProps, componentIs, componentProps } = useTransition(
  () => props,
  computed(() => ({
    active: ['overflow-hidden', directionClasses[props.direction].active].join(' '),
    hidden: ['opacity-0', directionClasses[props.direction].hidden].join(' '),
    visible: directionClasses[props.direction].visible,
  })),
);
</script>

<template>
  <component v-bind="{ ...classProps, ...componentProps, ...$attrs }" :is="componentIs">
    <slot></slot>
  </component>
</template>
